import { useLayoutEffect } from 'react';

import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { useServices } from 'hooks/useServices';
import { useAsyncBoundary } from 'utils/asyncBoundary/asyncBoundaryHooks';
import { useAppState } from 'hooks/useAppState';

export const useCardPaymentManagerDataProcess = (cardPaymentId: number) => {
  const dispatch = useAppDispatcher();

  const { injectPromise } = useAsyncBoundary();

  const { getCardPayment } = useServices();

  const {
    cardPaymentManager: {
      data: { cardPaymentInvalidated },
    },
  } = useAppState();

  useLayoutEffect(() => {
    if (cardPaymentInvalidated) {
      const promise = getCardPayment(cardPaymentId).then((cardPayment) => {
        dispatch({
          name: 'CardPaymentManager__DataRecieved',
          cardPayment,
        });
      });

      injectPromise(promise);
    }
  }, [
    cardPaymentId,
    cardPaymentInvalidated,
    dispatch,
    getCardPayment,
    injectPromise,
  ]);
};
